import HTTP_ERP from '@/config/axios-config-erp'

const ServicePelikane = {

  obtenerTraking(payload) {
    return HTTP_ERP.post(`/wscomun/portalinformes/pelikaneObtenerTracking`, payload).then((response) => {
      return response.data
    }).catch((error) => {
      console.log(error)
      return { 'status': 500 }
    })
  },
  obtenerUrlTracking(payload) {
    return HTTP_ERP.post(`/wscomun/portalinformes/obtenerUrlTracking`, payload).then((response) => {
      return response.data
    }).catch((error) => {
      console.log(error)
      return { 'status': 500 }
    })
  }

}

export default ServicePelikane



// WEBPACK FOOTER //
// ./src/services/srv-pelikane.js